import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getPlaylistId = async (name: string) => {
  const { data, error } = await supabase
    .from('playlists')
    .select('id')
    .eq('name', name)
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return data.id
}

export default function useGetPlaylistIdByName(name: string | undefined) {
  return useQuery({
    queryKey: ['useGetPlaylistIdByName', name],
    queryFn: () => getPlaylistId(name || ''),
    staleTime: 0,
    enabled: !!name,
  })
}
